import React from "react";
import { useTranslation } from "react-i18next";
import { CONSENT_STATUS_CLASS, ConsentStatus } from "./consentUtils";

const ConsentStatusBadge: React.FC<{ status: ConsentStatus }> = ({ status }) => {
  const { t } = useTranslation("consent");
  return (
    <span className={`text-xs px-2.5 py-1 rounded-full border ${CONSENT_STATUS_CLASS[status]}`}>
      {t(`status.${status}`)}
    </span>
  );
};

export default ConsentStatusBadge;
